// extracted by mini-css-extract-plugin
export default {"listItem":"people-step_listItem__f5HSu"};